var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecobcard-app"},[_c('notifications',{staticClass:"my-notification",attrs:{"group":"notification","position":"top center"}}),_c('gdpr-notice'),_c('trial-notice'),_c('router-view'),(_vm.$store.state.globalLoader)?_c('global-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }